var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"popup"},[_c('div',{staticClass:"outter_box"},[_c('div',{staticClass:"inner_box"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }